module.exports = __webpack_public_path__ + "static/media/england_PNG72.f65dfc56.png";